import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import FilterPagination from 'pages/parts/FilterPagination'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { checkFilter, checkPermission, chequeDates, formatDate, formatMoney, getCurrentChequeDate } from 'helpers/helpers'

function Sales() {
	const { t } = useTranslation()

	/* ZAKAZ MUDDATI KPI ustunlari — FULL tarif. Tarifda bo'lmasa ustunlar
	   umuman chizilmaydi (bo'sh ustun «dastur buzuq» taassurotini qoldiradi). */
	const canPlanDelivery = checkPermission('sec.delivery_planning')

	const date = new Date()
	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	};

	const [data, setData] = useState([])
	const [totalSales, setTotalSales] = useState(0)
	const [showModal, setShowModal] = useState({ show: false, data: {} })
	// Drill-down modalда SHAKL bo'yicha filtr (masalan «C35 gofra», «Tarnov 4b»):
	// har shakldan qancha metr sotilganini bilish uchun. null = hammasi.
	const [shapeFilter, setShapeFilter] = useState(null)

	/* AKSESSUAR/TUNUKAFON OYNASI uchun alohida holat.
	   NEGA KERAK: bu oynada 2 220 tagacha qator keladi (o'lchandi) va
	   ular BITTA sahifada chizilardi — o'qib bo'lmasdi. Endi oynaning
	   O'Z sahifalashi bor. Filtr esa bitta tugma ichiga yig'ildi. */
	const MODAL_PAGE_SIZE = 50
	const [mFilter, setMFilter] = useState({ shape: null, roll: null })
	const [mPage, setMPage] = useState(1)
	const [mOpen, setMOpen] = useState(false)
	const [mSearch, setMSearch] = useState('')

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: `/shifts/`,
		response: null
	})

	async function toggleModal(bool, item, product_type, mode = 'products') {
		if (bool) {
			const params = { ...filterData, cashier_login: item.login }
			if (product_type) params.product_type = product_type // faqat aniq tur; foyda modali barcha turlarni oladi
			const response = await GET('/report/cashiers/history', params, { loader: true })
			if (httpOk(response)) {
				// productType saqlanadi: tunikofon (5) modalида sarlavha KV ko'rsatishi kerak —
				// ustun ham KV, aks holda bitta katakda 2 xil raqam chiqardi.
				setShapeFilter(null) // yangi modal — filtr tozalanadi
				setMFilter({ shape: null, roll: null })
				setMPage(1)
				setMSearch('')
				setMOpen(false)
				setShowModal({ show: true, data: response.data, mode, productType: product_type })
			}

		} else {
			setShowModal({ ...showModal, show: false })
		}
	}

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}

	async function getData() {
		// checkFilter() ASYNC — await bo'lmasa state ga Promise yoziladi va u doim truthy,
		// natijada filtr bloki hech qanday filtr qo'yilmagan holda ham ko'rinadi (Sales.js da to'g'ri yozilgan).
		setFilterDataExist(await checkFilter(filterData, initialFilter));

		const response = await GET("/report/cashiers", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			// «Улуш» foizi va «Жами» qatori — BUTUN davr yig'indisidan (backend `totals`).
			// Avval faqat joriy sahifa qatorlari qo'shilardi: 20 dan ko'p sotuvchi bo'lganda
			// har sahifada ulushlar 100% ga yig'ilib, «Жами» ham sahifa yig'indisini ko'rsatardi.
			setTotalSales(parseFloat(response.data?.totals?.total_amount ?? 0))
			setPagination({ ...pagination, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}


	useEffect(() => {
		getData()
	}, [filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<style>{`
				.cashiers-table { font-size: 13px; }
				/* ── Aksessuar/Tunukafon oynasi ─────────────────────────── */
				.sl-sum { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
				.sl-box { flex: 1 1 0; min-width: 120px; padding: 8px 12px; background: #f7f8fb;
					border: 1px solid #e6e9f0; border-radius: 9px; }
				.sl-box span { display: block; font-size: 10.5px; letter-spacing: .06em;
					text-transform: uppercase; color: #98a2b3; margin-bottom: 1px; }
				.sl-box b { font-size: 17px; font-weight: 700; color: #1f2633;
					font-variant-numeric: tabular-nums; }
				.sl-box em { display: block; font-style: normal; font-size: 11px; color: #b45309; margin-top: 1px; }
				.sl-menu { min-width: 520px; padding: 12px; }
				.sl-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
				.sl-h { font-size: 10.5px; letter-spacing: .06em; text-transform: uppercase;
					color: #98a2b3; font-weight: 700; margin-bottom: 4px; }
				.sl-list { max-height: 260px; overflow-y: auto; display: flex; flex-direction: column; gap: 2px; }
				.sl-item { display: flex; align-items: center; justify-content: space-between; gap: 8px;
					width: 100%; padding: 5px 8px; border: 1px solid transparent; border-radius: 6px;
					background: transparent; font-size: 12.5px; text-align: left; cursor: pointer; }
				.sl-item:hover { background: #f2f4f7; }
				.sl-item.on { background: #f3effc; border-color: #6f42c1; color: #6f42c1; font-weight: 600; }
				.sl-item span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
				.sl-item em { flex: 0 0 auto; font-style: normal; font-size: 11px; color: #98a2b3;
					font-variant-numeric: tabular-nums; }
				.sl-empty { padding: 10px; font-size: 12.5px; color: #98a2b3; text-align: center; }
				.sl-tag { display: inline-flex; align-items: center; gap: 5px; padding: 3px 9px;
					background: #f3effc; border: 1px solid #d9cdf3; border-radius: 20px; font-size: 12px; }
				.sl-tag i { cursor: pointer; opacity: .6; }
				.sl-tag i:hover { opacity: 1; }
				.sl-wrap { max-height: 58vh; overflow-y: auto; }
				.sl-table { font-size: 12.5px; }
				.sl-table th { font-weight: 600; white-space: nowrap; position: sticky; top: 0; z-index: 1; }
				.sl-table td { white-space: nowrap; }
				.sl-ell { max-width: 210px; overflow: hidden; text-overflow: ellipsis; }
				.sl-pcs { font-size: 10.5px; padding: 1px 6px; border-radius: 20px;
					background: #eef2f6; color: #64748b; }
				.cashiers-table th { font-weight: 600; white-space: nowrap; vertical-align: middle; }
				.cashiers-table td { white-space: nowrap; }
				.cashiers-table tbody tr:hover { background-color: #f8f9fb; }
				.cashiers-table .cursor:hover { text-decoration: underline; }
			`}</style>

			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('sellers')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover align-middle mb-0 cashiers-table">
							<thead className="table-light">
								<tr>
									<th style={{ 'minWidth': '33px' }}>#</th>
									<th style={{ 'width': '10%' }}>{t('login')}</th>
									<th style={{ 'width': '10%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('cheques')}</th>
									<th style={{ 'minWidth': '90px' }} className="text-end">{t('average_cheque')}</th>
									{/* Birlik sarlavhada aniq ko'rsatiladi: profnastil/aksessuar — metr,
									    tunikofon — KV (ilovaning qolgan qismi bilan bir xil), produkt — dona */}
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">
										{t('profiled_sheeting')} <span className="fw-normal" style={{ fontSize: '11px' }}>({t('metr')})</span>
									</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">
										{t('accessory')} <span className="fw-normal" style={{ fontSize: '11px' }}>({t('metr')})</span>
									</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">
										{t('tunikofon')} <span className="fw-normal" style={{ fontSize: '11px' }}>({t('kv')})</span>
									</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">
										{t('products')} <span className="fw-normal" style={{ fontSize: '11px' }}>({t('pieces')})</span>
									</th>
									<th style={{ 'minWidth': '95px' }} className="text-end">{t('debt_given')}</th>
									<th style={{ 'minWidth': '95px' }} className="text-end">{t('debt_remaining')}</th>
									<th style={{ 'width': '7%' }} className="text-end">{t('discount_amount')}</th>
									<th style={{ 'minWidth': '95px' }} className="text-end">{t('returned')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('sale_amount')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-end">{t('profit')}</th>
									<th style={{ 'width': '6%' }} className="text-center">{t('share')}</th>
									{/* ⚠️ SARLAVHA ATAYLAB O'ZGARTIRILDI (2026-08-14).
									Ilgari shunchaki «O'chirilgan cheklar» edi va korxona egasi uni
									«bu sotuvchi shuncha chek o'chirgan» deb o'qidi. Aslida bu ustun
									`cashier_login` bo'yicha guruhlanadi — ya'ni chekni YOZGAN odam.
									Kim o'chirgani (`deleted_by`) bu yerda umuman ishlatilmaydi.
									Sarlavha endi shuni aytadi, tafsiloti esa tooltipda. */}
								<th style={{ 'minWidth': '115px' }} className="text-end"
									title={t('deleted_written_cheques_hint')}>
									⚠️ {t('deleted_written_cheques')}
								</th>

								{/* ZAKAZ MUDDATI KPI si (full tarif). Prodda o'lchandi:
								    sotuvchilar orasidagi farq 96.5% dan 88.9% gacha, eng katta
								    kechikish 1 kun va 27 kun — ya'ni sex quvvati emas, VA'DA
								    BERISH uslubi hal qiladi. Shuning uchun bu ustunlar. */}
								{canPlanDelivery && <>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('dp_orders')}</th>
									<th style={{ 'minWidth': '80px' }} className="text-center">{t('dp_on_time')}</th>
									<th style={{ 'minWidth': '90px' }} className="text-end"
										title={t('dp_max_late')}>{t('dp_late')}</th>
									<th style={{ 'minWidth': '95px' }} className="text-end">{t('dp_same_day')}</th>
								</>}

								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => {
									const share = totalSales > 0 ? (parseFloat(item.total_amount) / totalSales * 100).toFixed(1) : 0
									const avgCheque = Number(item.total_cheques) > 0 ? parseFloat(item.total_amount) / Number(item.total_cheques) : 0
									const margin = parseFloat(item.total_amount) > 0 ? (parseFloat(item.total_profit) / parseFloat(item.total_amount) * 100).toFixed(1) : 0
									const profitClass = parseFloat(item.total_profit) >= 0 ? 'text-success' : 'text-danger'
									const marginBadge = parseFloat(margin) >= 15 ? 'bg-success' : parseFloat(margin) >= 8 ? 'bg-warning text-dark' : 'bg-light text-dark border'
									return (
										<tr key={index}>
											<td className="text-muted">{item.row_number}</td>
											<td className="fw-500">{item.login}</td>
											<td className="td-ellipsis text-muted">{item.name}</td>
											<td className="text-end">{formatMoney(item.total_cheques, 2)}</td>
											<td className="text-end">{formatMoney(avgCheque)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 4)}>{formatMoney(item.products_type_4, 2)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 3)}>{formatMoney(item.products_type_3, 2)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 5)}>{formatMoney(item.products_type_5, 2)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 1)}>{formatMoney(item.products_type_1, 2)}</td>
											<td className="text-end" style={{ color: '#d97706' }}>{Number(item.total_debt) > 0 ? formatMoney(item.total_debt, 2) : <span className="text-muted">0</span>}</td>
											{/* Qolgan qarz = berilgan − ₴ orqali qaytarilgan (kanonik formula) */}
											<td className="text-end fw-500" style={{ color: '#dc2626' }}>{Number(item.total_debt_remaining) > 0 ? formatMoney(item.total_debt_remaining, 2) : <span className="text-muted">0</span>}</td>
											<td className="text-end text-muted">{formatMoney(item.total_discount, 2)}</td>
											{/* QAYTARILGAN (ADR-011) — «Савдо» ustunidan allaqachon ayirilgan,
											    bu yerda qancha ayirilgani ochiq ko'rsatiladi. */}
											<td className="text-end" style={{ color: '#dc2626' }}>
												{Number(item.total_returned) > 0
													? '−' + formatMoney(item.total_returned, 2)
													: <span className="text-muted">0</span>}
											</td>
											<td className="text-end fw-bold">{formatMoney(item.total_amount, 2)}</td>
											<td className="text-end cursor" onClick={() => toggleModal(true, item, null, 'profit')}>
												<div className={'fw-bold ' + profitClass}>{formatMoney(item.total_profit, 2)}</div>
												<span className={'badge ' + marginBadge}>{margin}%</span>
											</td>
											<td className="text-center">
												<span className={`badge ${parseFloat(share) >= 20 ? 'bg-success' : parseFloat(share) >= 5 ? 'bg-warning text-dark' : 'bg-light text-dark border'}`}>
													{share}%
												</span>
											</td>
											<td className="text-end">
												{Number(item.deleted_count) > 0
													? <span className="badge bg-danger">{item.deleted_count} {t('pieces')} · {formatMoney(item.deleted_amount)}</span>
													: <span className="text-muted">0</span>
												}
											</td>

											{/* ZAKAZ MUDDATI KPI si — rang bilan: 95%+ yashil, 90-95% sariq, past qizil */}
											{canPlanDelivery && <>
												<td className="text-end">
													{Number(item.dp_orders) > 0
														? formatMoney(item.dp_orders, 2)
														: <span className="text-muted">0</span>}
												</td>
												<td className="text-center">
													{(item.dp_on_time_pct !== null && item.dp_on_time_pct !== undefined)
														? <span className={`badge ${Number(item.dp_on_time_pct) >= 95 ? 'bg-success'
															: Number(item.dp_on_time_pct) >= 90 ? 'bg-warning text-dark' : 'bg-danger'}`}>
															{item.dp_on_time_pct}%
														</span>
														: <span className="text-muted">—</span>}
												</td>
												<td className="text-end">
													{Number(item.dp_late) > 0
														? <span title={`${t('dp_max_late')}: ${item.dp_max_late}`}>
															{item.dp_late}
															{!!item.dp_avg_late &&
																<span className="text-muted fz-14"> (~{item.dp_avg_late})</span>}
														</span>
														: <span className="text-muted">0</span>}
												</td>
												<td className="text-end">
													{Number(item.dp_orders) > 0
														? <span className="text-muted">
															{Math.round(100 * Number(item.dp_same_day) / Number(item.dp_orders))}%
														</span>
														: <span className="text-muted">—</span>}
												</td>
											</>}
										</tr>
									)
								})}
							</tbody>
							{data?.data?.length > 0 &&
								<tfoot className="table-secondary fw-bold">
									<tr>
										{(() => {
											// «Жами» — backend `totals` dan, ya'ni BUTUN davr bo'yicha (sahifa emas).
											const tt = data.totals ?? {}
											const num = (v) => parseFloat(v ?? 0)
											const totalCheques = num(tt.total_cheques)
											const avgAll = totalCheques > 0 ? totalSales / totalCheques : 0
											const totalProfit = num(tt.total_profit)
											const marginAll = totalSales > 0 ? (totalProfit / totalSales * 100).toFixed(1) : 0
											return (
												<>
													<td colSpan="3" className="fw-bold">{t('total')}</td>
													<td className="text-end fw-bold">{formatMoney(totalCheques, 2)}</td>
													<td className="text-end fw-bold">{formatMoney(avgAll)}</td>
													<td className="text-end fw-bold">{formatMoney(num(tt.products_type_4), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(num(tt.products_type_3), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(num(tt.products_type_5), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(num(tt.products_type_1), 2)}</td>
													<td className="text-end fw-bold" style={{ color: '#d97706' }}>{formatMoney(num(tt.total_debt), 2)}</td>
													<td className="text-end fw-bold" style={{ color: '#dc2626' }}>{formatMoney(num(tt.total_debt_remaining), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(num(tt.total_discount), 2)}</td>
													{/* Qaytarilgan jami (ADR-011) */}
													<td className="text-end fw-bold" style={{ color: '#dc2626' }}>
														{num(tt.total_returned) > 0 ? '−' + formatMoney(num(tt.total_returned), 2) : 0}
													</td>
													<td className="text-end fw-bold">{formatMoney(totalSales, 2)}</td>
													<td className="text-end fw-bold">
														<div className={totalProfit >= 0 ? 'text-success' : 'text-danger'}>{formatMoney(totalProfit, 2)}</div>
														<span className="badge bg-secondary">{marginAll}%</span>
													</td>
													<td className="text-center fw-bold">100%</td>
													<td className="text-end fw-bold text-danger">
														{num(tt.deleted_count)} {t('pieces')} · {formatMoney(num(tt.deleted_amount))}
													</td>
												</>
											)
										})()}
									</tr>
								</tfoot>
							}
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Modal show={showModal.show} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)} size="xl">
				{(() => {
					/* AKSESSUAR (3) va TUNUKAFON (5) — YANGI, tartiblangan ko'rinish.
					   Qolgan turlar (Profnastil 4, Produkt 1) ESKI ko'rinishda qoladi:
					   user aniq aytdi — «profnastilga tegma». */
					const pt = Number(showModal.productType)
					const isDetail = pt === 3 || pt === 5
					const isKv = pt === 5
					const rows = showModal?.data?.data ?? []
					const num = (v) => parseFloat(v ?? 0) || 0

					if (!isDetail) {
						// ── ESKI KO'RINISH (tegilmagan) ──────────────────────────
						return (<>
							<Modal.Header closeButton>
								<Modal.Title>
									{showModal.data.cashier_login} {showModal.mode === 'profit'
										/* ⚠️ QAYTARILGAN FOYDA ham ayiriladi (2026-08-13).
										   Ustun endi `foyda − chegirma − qaytarilgan foyda`
										   (ReportController :1732), bu sarlavha esa faqat
										   `foyda − chegirma` edi — ikkisi AYNAN qaytarilgan
										   foyda miqdoricha ajralib qolgan edi. Backend
										   `total_returned_profit` ni allaqachon yuboradi,
										   lekin u faqat tur 3/5 ko'rinishida o'qilardi.
										   O'lchandi: abdulbosit0105 4 475 610 farq. */
										? `— ${t('profit')}: ${formatMoney(
											rows.reduce((s2, i2) => s2 + num(i2.profit), 0)
											- num(showModal?.data?.total_discount)
											- num(showModal?.data?.total_returned_profit)
										)}`
										: `[${formatMoney(showModal.data.total_metr_sold)} ${t('metr')}]`
									}
								</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th style={{ minWidth: '33px' }} className="text-center">#</th>
												<th style={{ width: '5%' }} className="text-start">{t('cheque')} ID</th>
												<th style={{ width: '18%' }}>{t('shape')}</th>
												<th style={{ width: '15%' }}>{t('roll')}</th>
												<th style={{ width: '10%' }} className="text-center">{t('date')}</th>
												<th style={{ width: '8%' }} className="text-end">{t('quantity')}</th>
												<th style={{ width: '8%' }} className="text-end">{t('size')}</th>
												<th style={{ width: '8%' }} className="text-end">{t('metr')}</th>
												<th style={{ width: '8%' }} className="text-end">{t('price')}</th>
												<th style={{ width: '10%' }} className="text-end">{t('amount')}</th>
												{showModal.mode === 'profit' && <th style={{ width: '10%' }} className="text-end text-success">{t('profit')}</th>}
											</tr>
										</thead>
										<tbody>
											{rows.map((item, index) => (
												<tr className="tr-middle" key={index}>
													<td className="text-center">{index + 1}</td>
													<td className="text-start">{item.cheque_id}</td>
													<td>{item.name}</td>
													<td className="text-muted">{item.element_name || <span className="text-muted">—</span>}</td>
													<td className="text-center">{formatDate(item.cheque_closed_at)}</td>
													<td className="text-end">{formatMoney(item.quantity, 2)}</td>
													<td className="text-end">{formatMoney(item.element_quantity, 2)}</td>
													<td className="text-end">{formatMoney(item.metr, 2)}</td>
													<td className="text-end">{formatMoney(item.sale_price)}</td>
													<td className="text-end">{formatMoney(item.total_price)}</td>
													{showModal.mode === 'profit' && <td className="text-end text-success fw-bold">{formatMoney(item.profit)}</td>}
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</Modal.Body>
						</>)
					}

					// ── YANGI KO'RINISH (aksessuar / tunukafon) ──────────────────
					// Shakl va rulon ro'yxatlari — filtr tugmasi ichida chiqadi
					const shapes = new Map()
					const rolls = new Map()
					rows.forEach(r => {
						const sk = r.name || '—'
						const cur = shapes.get(sk) ?? { metr: 0, kv: 0, n: 0 }
						cur.metr += num(r.metr); cur.kv += num(r.kv); cur.n += 1
						shapes.set(sk, cur)
						const rk = r.element_name || '—'
						const cr = rolls.get(rk) ?? { n: 0 }
						cr.n += 1; rolls.set(rk, cr)
					})

					const filtered = rows.filter(r =>
						(mFilter.shape === null || (r.name || '—') === mFilter.shape) &&
						(mFilter.roll === null || (r.element_name || '—') === mFilter.roll))

					// Jamlanma — FILTRLANGAN qatorlar bo'yicha (ko'rinayotgani bilan mos)
					const hasFilter = mFilter.shape !== null || mFilter.roll !== null

					/* QAYTARILGAN TOVAR (ADR-011) — 2026-08-12.
					   Ro'yxatdagi USTUN qaytarilgani ayirilgan sonni ko'rsatadi,
					   bu modal esa qatorlarni qo'shib chiqarardi — ikkisi mos
					   kelmasdi (o'lchandi: 345 033 farq).

					   ⚠️ Shakl/rulon filtri yoqilganda AYIRMAYMIZ: backend
					      qaytarish jamlanmasini butun davr uchun beradi, uni
					      filtrlangan qismga tatbiq etish soxta raqam chiqarardi.
					      Bunday paytda jamlanma ko'rinayotgan qatorlarniki bo'lib
					      qoladi (pastda «filtr yoqilgan» belgisi bor). */
					const retSum = hasFilter ? 0 : num(showModal?.data?.total_returned)
					const retProfit = hasFilter ? 0 : num(showModal?.data?.total_returned_profit)
					const retMetr = hasFilter ? 0 : num(showModal?.data?.total_returned_metr)
					const retKv = hasFilter ? 0 : num(showModal?.data?.total_returned_kv)

					const sMetr = filtered.reduce((a, r) => a + num(r.metr), 0) - retMetr
					const sKv = filtered.reduce((a, r) => a + num(r.kv), 0) - retKv
					const sSum = filtered.reduce((a, r) => a + num(r.total_price), 0) - retSum
					const sProfit = filtered.reduce((a, r) => a + num(r.profit), 0) - retProfit
					/* METRSIZ qatorlar. Aksessuarning bir qismi DONA bilan sotiladi
					   (masalan «Tarnov 3b» — 60 dona), ularda metr umuman yo'q.
					   Ilgari sarlavhada faqat metr turardi va «jami 53 101 metr»
					   deb yozilardi — dona bilan sotilganlari qayerga ketgani
					   tushunarsiz edi. Endi ular alohida sanaladi. */
					const noMetr = filtered.filter(r => !num(r.metr))
					const noMetrQty = noMetr.reduce((a, r) => a + num(r.quantity), 0)

					const pages = Math.max(1, Math.ceil(filtered.length / MODAL_PAGE_SIZE))
					const page = Math.min(mPage, pages)
					const pageRows = filtered.slice((page - 1) * MODAL_PAGE_SIZE, page * MODAL_PAGE_SIZE)

					const q = mSearch.trim().toLowerCase()
					const shapeList = [...shapes.entries()]
						.filter(([k]) => !q || k.toLowerCase().includes(q))
						.sort((a, b) => b[1].metr - a[1].metr || b[1].n - a[1].n)
					const rollList = [...rolls.entries()]
						.filter(([k]) => !q || k.toLowerCase().includes(q))
						.sort((a, b) => b[1].n - a[1].n)

					return (<>
						<Modal.Header closeButton>
							<Modal.Title style={{ fontSize: 17 }}>
								{showModal.data.cashier_login}
								<span className="text-muted ms-2" style={{ fontSize: 13 }}>
									{isKv ? t('tunikofon') : t('accessory')} · {formatDate(filterData.start_date)} — {formatDate(filterData.end_date)}
								</span>
							</Modal.Title>
						</Modal.Header>

						<Modal.Body>
							{/* JAMLANMA — avval RAQAM, keyin tafsilot. Rahbar odatda
							    faqat shu qatordan foydalanadi. */}
							<div className="sl-sum">
								<div className="sl-box">
									<span>{t('metr')}</span>
									<b>{formatMoney(sMetr, 2)}</b>
								</div>
								{isKv &&
									<div className="sl-box">
										<span>{t('kv')}</span>
										<b>{formatMoney(sKv, 2)}</b>
									</div>
								}
								<div className="sl-box">
									<span>{t('amount')}</span>
									<b>{formatMoney(sSum)}</b>
								</div>
								{retSum > 0 &&
									<div className="sl-box">
										<span>{t('returned')}</span>
										<b className="text-danger">-{formatMoney(retSum)}</b>
									</div>
								}
								{showModal.mode === 'profit' &&
									<div className="sl-box">
										<span>{t('profit')}</span>
										<b className={sProfit >= 0 ? 'text-success' : 'text-danger'}>{formatMoney(sProfit)}</b>
									</div>
								}
								<div className="sl-box">
									<span>{t('lines_count')}</span>
									<b>{filtered.length}</b>
									{noMetr.length > 0 &&
										<em title={t('sold_by_pieces')}>
											{noMetr.length} {t('without_metr')} · {formatMoney(noMetrQty, 2)} {t('pieces')}
										</em>
									}
								</div>
							</div>

							{/* FILTR — BITTA TUGMA ICHIDA (user talabi).
							    Ilgari o'nlab shakl «chip» bo'lib bir necha qator
							    bo'lib yotardi va jadvalni pastga surib yuborardi. */}
							<div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
								<Dropdown show={mOpen} onToggle={(v) => { setMOpen(v); if (!v) setMSearch('') }}>
									<Dropdown.Toggle variant={hasFilter ? 'primary' : 'outline-primary'} size="sm">
										<i className="uil-filter me-1" />{t('filter')}
										{hasFilter && <span className="badge bg-light text-dark ms-2">
											{[mFilter.shape, mFilter.roll].filter(Boolean).length}
										</span>}
									</Dropdown.Toggle>
									<Dropdown.Menu className="sl-menu">
										<input className="form-control form-control-sm mb-2" placeholder={t('search')}
											value={mSearch} onChange={(e) => setMSearch(e.target.value)} />
										<div className="sl-cols">
											<div>
												<div className="sl-h">{t('shape')}</div>
												<div className="sl-list">
													<button className={'sl-item' + (mFilter.shape === null ? ' on' : '')}
														onClick={() => { setMFilter({ ...mFilter, shape: null }); setMPage(1) }}>
														{t('all')}<em>{rows.length}</em>
													</button>
													{shapeList.length === 0 && <div className="sl-empty">{t('nothing_found')}</div>}
													{shapeList.map(([k, v]) => (
														<button key={k} className={'sl-item' + (mFilter.shape === k ? ' on' : '')}
															onClick={() => { setMFilter({ ...mFilter, shape: mFilter.shape === k ? null : k }); setMPage(1) }}>
															<span title={k}>{k}</span>
															<em>{formatMoney(v.metr, 1)} {t('metr')}</em>
														</button>
													))}
												</div>
											</div>
											<div>
												<div className="sl-h">{t('roll')}</div>
												<div className="sl-list">
													<button className={'sl-item' + (mFilter.roll === null ? ' on' : '')}
														onClick={() => { setMFilter({ ...mFilter, roll: null }); setMPage(1) }}>
														{t('all')}<em>{rows.length}</em>
													</button>
													{rollList.length === 0 && <div className="sl-empty">{t('nothing_found')}</div>}
													{rollList.map(([k, v]) => (
														<button key={k} className={'sl-item' + (mFilter.roll === k ? ' on' : '')}
															onClick={() => { setMFilter({ ...mFilter, roll: mFilter.roll === k ? null : k }); setMPage(1) }}>
															<span title={k}>{k}</span>
															<em>{v.n}</em>
														</button>
													))}
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>

								{mFilter.shape && <span className="sl-tag">{t('shape')}: <b>{mFilter.shape}</b>
									<i className="uil-times" onClick={() => { setMFilter({ ...mFilter, shape: null }); setMPage(1) }} /></span>}
								{mFilter.roll && <span className="sl-tag">{t('roll')}: <b>{mFilter.roll}</b>
									<i className="uil-times" onClick={() => { setMFilter({ ...mFilter, roll: null }); setMPage(1) }} /></span>}
								{hasFilter &&
									<button className="btn btn-link btn-sm text-decoration-none p-0"
										onClick={() => { setMFilter({ shape: null, roll: null }); setMPage(1) }}>
										{t('clear_filter')}
									</button>
								}
								<span className="ms-auto text-muted" style={{ fontSize: 12.5 }}>
									{t('rows_shown')}: {pageRows.length} / {filtered.length}
								</span>
							</div>

							<div className="table-responsive sl-wrap">
								<table className="table table-bordered table-hover align-middle mb-0 sl-table">
									<thead className="table-light">
										<tr>
											<th style={{ width: 40 }} className="text-center">#</th>
											<th style={{ width: 70 }}>{t('cheque')}</th>
											<th style={{ width: 92 }} className="text-center">{t('date')}</th>
											<th>{t('shape')}</th>
											<th>{t('roll')}</th>
											<th style={{ width: 72 }} className="text-end">{t('quantity')}</th>
											<th style={{ width: 78 }} className="text-end">{t('size')}</th>
											<th style={{ width: 84 }} className="text-end">{t('metr')}</th>
											{/* ⚠️ KV ustuni FAQAT tunikofonda. Aksessuarda u
											    2 220 qatorning HAMMASIDA bo'sh edi (o'lchandi) —
											    bo'sh ustun jadvalni kengaytirib, chalg'itardi. */}
											{isKv && <th style={{ width: 84 }} className="text-end">{t('kv')}</th>}
											<th style={{ width: 92 }} className="text-end">{t('price')}</th>
											<th style={{ width: 105 }} className="text-end">{t('amount')}</th>
											{showModal.mode === 'profit' && <th style={{ width: 100 }} className="text-end">{t('profit')}</th>}
										</tr>
									</thead>
									<tbody>
										{pageRows.length === 0 &&
											<tr><td colSpan={isKv ? 11 : 10} className="text-center text-muted py-4">{t('nothing_found')}</td></tr>
										}
										{pageRows.map((item, index) => {
											const hasMetr = num(item.metr) > 0
											return (
												<tr key={index}>
													<td className="text-center text-muted">{(page - 1) * MODAL_PAGE_SIZE + index + 1}</td>
													<td className="fw-500">#{item.cheque_id}</td>
													<td className="text-center text-muted text-nowrap">{formatDate(item.cheque_closed_at)}</td>
													<td className="sl-ell" title={item.name}>{item.name}</td>
													<td className="sl-ell text-muted" title={item.element_name || ''}>
														{item.element_name || <span className="text-muted">—</span>}
													</td>
													<td className="text-end">{formatMoney(item.quantity, 2)}</td>
													<td className="text-end text-muted">
														{num(item.element_quantity) > 0 ? formatMoney(item.element_quantity, 2) : <span className="text-muted">—</span>}
													</td>
													{/* Metr yo'q = DONA bilan sotilgan. Bo'sh katak
													    o'rniga aniq yozuv — «nol» deb tushunilmasin. */}
													<td className="text-end">
														{hasMetr
															? formatMoney(item.metr, 2)
															: <span className="sl-pcs" title={t('sold_by_pieces')}>{t('pieces')}</span>}
													</td>
													{isKv && <td className="text-end">{formatMoney(item.kv, 2)}</td>}
													<td className="text-end text-muted">{formatMoney(item.sale_price)}</td>
													<td className="text-end fw-500">{formatMoney(item.total_price)}</td>
													{showModal.mode === 'profit' &&
														<td className={'text-end fw-bold ' + (num(item.profit) >= 0 ? 'text-success' : 'text-danger')}>
															{formatMoney(item.profit)}
														</td>}
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>

							{/* OYNANING O'Z SAHIFALASHI.
							    ⚠️ Ilgari bu yerda sahifa tugmalari SOTUVCHILAR
							    ro'yxatining paginatsiyasiga ulangan edi — bosilganda
							    orqadagi jadval sahifasi almashardi, oyna esa
							    o'zgarmasdi. Endi bog'liqlik yo'q. */}
							{pages > 1 &&
								<div className="d-flex justify-content-center align-items-center gap-2 mt-3">
									<button className="btn btn-sm btn-outline-secondary" disabled={page <= 1}
										onClick={() => setMPage(page - 1)}><i className="uil-angle-left" /></button>
									<span style={{ fontSize: 13 }}>{page} / {pages}</span>
									<button className="btn btn-sm btn-outline-secondary" disabled={page >= pages}
										onClick={() => setMPage(page + 1)}><i className="uil-angle-right" /></button>
								</div>
							}
						</Modal.Body>
					</>)
				})()}
			</Modal>
		</>
	)
}

export default Sales